var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "top-filters-container" },
    [
      _c(
        "panel-wrapper",
        {
          attrs: { active: _vm.filtersCount > 0, count: _vm.filtersCount },
          on: {
            apply: _vm.onSubmit,
            clear: _vm.clearFilters,
            click: _vm.hideCategoriesDropdown
          }
        },
        [
          _c("h1", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("Wybierz filtry i odszukaj idealny prezent")
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "mobile-sort-panel-menu-wrapper",
              attrs: { slot: "content", action: "", method: "get" },
              slot: "content"
            },
            [
              _c("div", { staticClass: "scrollbar" }, [
                _c(
                  "ul",
                  { staticClass: "mobile-menu" },
                  _vm._l(_vm.categories, function(category) {
                    return _c(
                      "li",
                      { staticClass: "mobile-item" },
                      [
                        _c(
                          "group-category",
                          {
                            attrs: {
                              title: _vm.resolveCategoryName(category),
                              loading: _vm.isLoading
                            }
                          },
                          _vm._l(category.children, function(child) {
                            return _c("item-category", {
                              key: "categoryItem" + child.id,
                              attrs: {
                                "hide-group-on-click": false,
                                loading: _vm.isLoading,
                                category: child,
                                "checked-categories": _vm.checkedCategories
                              },
                              on: {
                                "check-category": _vm.checkCategory,
                                "remove-category": _vm.removeCategory
                              }
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "block-content" },
                          [
                            _c("item-selected", {
                              style: { padding: "0 20px" },
                              attrs: {
                                "checked-categories": _vm.getGroupedCategories(
                                  category.id
                                )
                              },
                              on: { "remove-category": _vm.removeCategory }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }